(() => {
  function initDiscountScript() {
    const appliedDiscountsContainer = document.getElementById('applied-discounts');
    const applyBtn = document.getElementById('apply-discount-btn');
    const discountInput = document.getElementById('discount-input');

    // Prevent duplicate event listeners
    const container = document.getElementById('discount-code-container');

    if (container && container.dataset.discountScriptInitialized === 'true') {
      return;
    }

    if (container) {
      container.dataset.discountScriptInitialized = 'true';
    }

    if (!appliedDiscountsContainer || !applyBtn || !discountInput) {
      return;
    }

    const strings = window.cartDiscountStrings || {};

    const MSG_NO_CODE =
      strings.errorNoCode || "Please enter a discount code.";

    const MSG_ALREADY_APPLIED =
      strings.errorAlreadyApplied || "That discount code is already applied.";

    const MSG_INVALID =
      strings.errorInvalid || "Discount code is invalid or not applicable.";

    /**
     * Clear discount error message
     */
    function clearMessages() {
      const errDiv = document.getElementById('discount-error-message');

      if (errDiv) {
        errDiv.style.display = 'none';
        errDiv.textContent = '';
      }
    }

    /**
     * Show discount error message
     */
    function showError(msg) {
      const errDiv = document.getElementById('discount-error-message');

      if (errDiv) {
        errDiv.style.display = 'block';
        errDiv.textContent = msg;
      }
    }

    /**
     * Get currently displayed discount codes
     */
    function getCurrentDiscounts() {
      const pills = document.querySelectorAll(
        '#applied-discounts .discount-pill'
      );

      return Array.from(pills)
        .map((pill) => {
          const code = pill.getAttribute('data-code');
          return code ? code.toUpperCase() : '';
        })
        .filter(Boolean);
    }

    /**
     * Dispatch an event when KAHINA10 has really been accepted
     * by Shopify.
     */
    function dispatchKahina10Applied() {
      window.dispatchEvent(
        new CustomEvent('sakinae:kahina10-applied', {
          detail: {
            code: 'KAHINA10'
          }
        })
      );
    }

    /**
     * Dispatch an event when KAHINA10 is removed.
     */
    function dispatchKahina10Removed() {
      window.dispatchEvent(
        new CustomEvent('sakinae:kahina10-removed', {
          detail: {
            code: 'KAHINA10'
          }
        })
      );
    }

    /**
     * Update the cart drawer/cart section
     */
    function triggerCartUpdate() {
      const cartDrawerItems = document.querySelector('cart-drawer-items');

      if (
        cartDrawerItems &&
        typeof cartDrawerItems.updateQuantity === 'function'
      ) {
        const qtyInput =
          document.getElementById('Drawer-quantity-1') ||
          document.getElementById('Quantity-1');

        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;

          cartDrawerItems.updateQuantity(1, currentQty);
          return;
        } else if (
          typeof cartDrawerItems.onCartUpdate === 'function'
        ) {
          cartDrawerItems.onCartUpdate();
          return;
        }
      }

      const cartItems = document.querySelector('cart-items');

      if (
        cartItems &&
        typeof cartItems.updateQuantity === 'function'
      ) {
        const qtyInput =
          document.getElementById('Quantity-1') ||
          document.getElementById('Drawer-quantity-1');

        if (qtyInput) {
          const currentQty = parseInt(qtyInput.value, 10) || 1;

          cartItems.updateQuantity(1, currentQty);
          return;
        } else if (
          typeof cartItems.onCartUpdate === 'function'
        ) {
          cartItems.onCartUpdate();
          return;
        }
      }
    }

    /**
     * Apply Shopify discount codes
     */
    async function applyDiscounts(discountCodes = []) {
      let isRemoving = false;

      if (discountCodes.length === 0) {
        discountCodes = ['REMOVE_SHOPIFY_CODE'];
        isRemoving = true;
      }

      const discountString = discountCodes.join(',');

      const checkoutUrl =
        `/checkout?discount=${encodeURIComponent(discountString)}`;

      try {
        await fetch(checkoutUrl, {
          method: 'GET',
          credentials: 'same-origin'
        });
      } catch (err) {
        // Shopify may redirect or reject the request,
        // so we continue and verify the cart directly.
      }

      let cartData;

      try {
        const cartRes = await fetch('/cart.js', {
          method: 'GET',
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!cartRes.ok) {
          throw new Error('Unable to retrieve cart.');
        }

        cartData = await cartRes.json();
      } catch (err) {
        return {
          success: false,
          invalidCodes: discountCodes
        };
      }

      /**
       * Build the list of discounts Shopify actually applied.
       */
      const validSet = new Set();

      (
        cartData.cart_level_discount_applications || []
      ).forEach((discount) => {
        if (
          discount &&
          discount.title
        ) {
          validSet.add(
            discount.title.toUpperCase()
          );
        }
      });

      (
        cartData.items || []
      ).forEach((item) => {
        (
          item.line_level_discount_allocations || []
        ).forEach((allocation) => {
          if (
            allocation &&
            allocation.discount_application &&
            allocation.discount_application.title
          ) {
            validSet.add(
              allocation.discount_application.title.toUpperCase()
            );
          }
        });
      });

      /**
       * Determine which requested codes Shopify did not accept.
       */
      const invalidCodes = discountCodes.filter(
        (code) =>
          !validSet.has(
            code.toUpperCase()
          )
      );

      const newlyAddedCode =
        discountCodes[discountCodes.length - 1];

      const normalizedNewCode =
        newlyAddedCode
          ? newlyAddedCode.toUpperCase()
          : '';

      const codeIsInvalid =
        invalidCodes.some(
          (code) =>
            code.toUpperCase() === normalizedNewCode
        );

      /**
       * Update cart if the operation succeeded.
       */
      if (
        newlyAddedCode === 'REMOVE_SHOPIFY_CODE' ||
        !codeIsInvalid
      ) {
        triggerCartUpdate();
      }

      /**
       * IMPORTANT:
       *
       * Only trigger KAHINA10 when Shopify actually
       * confirms that the code exists in the cart.
       */
      if (
        normalizedNewCode === 'KAHINA10' &&
        !codeIsInvalid
      ) {
        dispatchKahina10Applied();
      }

      /**
       * If the user removed KAHINA10, notify the cart drawer.
       */
      if (
        isRemoving &&
        !validSet.has('KAHINA10')
      ) {
        dispatchKahina10Removed();
      }

      return {
        success: !codeIsInvalid || isRemoving,
        invalidCodes,
        cart: cartData
      };
    }

    /**
     * Apply discount button
     */
    applyBtn.addEventListener('click', async () => {
      clearMessages();

      const existingCodes = getCurrentDiscounts();

      const newCode =
        discountInput.value
          .trim()
          .toUpperCase();

      /**
       * No code entered
       */
      if (!newCode) {
        showError(MSG_NO_CODE);
        return;
      }

      /**
       * Code already applied
       */
      if (existingCodes.includes(newCode)) {
        showError(MSG_ALREADY_APPLIED);
        return;
      }

      /**
       * Loading animation
       */
      const originalBtnText =
        applyBtn.textContent.trim();

      let dotCount = 0;
      let loading = true;

      applyBtn.disabled = true;

      const animateDots = () => {
        if (!loading) {
          return;
        }

        dotCount = (dotCount + 1) % 4;

        applyBtn.textContent =
          originalBtnText +
          '.'.repeat(dotCount);

        setTimeout(
          animateDots,
          400
        );
      };

      animateDots();

      /**
       * Apply existing codes + new code
       */
      const combinedCodes = [
        ...existingCodes,
        newCode
      ];

      let result;

      try {
        result =
          await applyDiscounts(
            combinedCodes
          );
      } catch (error) {
        result = {
          success: false,
          invalidCodes: [newCode]
        };
      }

      /**
       * Stop loading animation
       */
      loading = false;

      applyBtn.textContent =
        originalBtnText;

      applyBtn.disabled = false;

      /**
       * Check if the new code was rejected.
       */
      const normalizedInvalidCodes =
        (result.invalidCodes || [])
          .map((code) =>
            code.toUpperCase()
          );

      const newCodeIsInvalid =
        normalizedInvalidCodes.includes(
          newCode
        );

      if (newCodeIsInvalid) {
        showError(MSG_INVALID);
      }

      /**
       * Clear the input after a successful application.
       */
      if (!newCodeIsInvalid) {
        discountInput.value = '';
      }
    });

    /**
     * Remove discount code
     */
    appliedDiscountsContainer.addEventListener(
      'click',
      async (event) => {
        const removeButton =
          event.target.closest(
            '.remove-discount'
          );

        if (!removeButton) {
          return;
        }

        clearMessages();

        const pill =
          event.target.closest(
            '.discount-pill'
          );

        if (!pill) {
          return;
        }

        const codeToRemove =
          pill.getAttribute(
            'data-code'
          );

        if (!codeToRemove) {
          return;
        }

        const normalizedCodeToRemove =
          codeToRemove.toUpperCase();

        const existingCodes =
          getCurrentDiscounts();

        const newDiscountList =
          existingCodes.filter(
            (code) =>
              code !==
              normalizedCodeToRemove
          );

        /**
         * If removing KAHINA10, explicitly
         * notify the cart drawer after Shopify
         * has processed the removal.
         */
        const removingKahina10 =
          normalizedCodeToRemove ===
          'KAHINA10';

        const result =
          await applyDiscounts(
            newDiscountList
          );

        /**
         * applyDiscounts() already dispatches
         * the removal event for KAHINA10.
         *
         * This fallback ensures the event is
         * also dispatched if Shopify accepted
         * the removal but the normal branch
         * did not fire for some reason.
         */
        if (
          removingKahina10 &&
          result &&
          result.success
        ) {
          setTimeout(async () => {
            try {
              const cartRes =
                await fetch(
                  '/cart.js',
                  {
                    method: 'GET',
                    credentials: 'same-origin',
                    cache: 'no-store'
                  }
                );

              if (!cartRes.ok) {
                return;
              }

              const cart =
                await cartRes.json();

              const validDiscounts =
                new Set();

              (
                cart.cart_level_discount_applications ||
                []
              ).forEach((discount) => {
                if (
                  discount &&
                  discount.title
                ) {
                  validDiscounts.add(
                    discount.title.toUpperCase()
                  );
                }
              });

              (
                cart.items || []
              ).forEach((item) => {
                (
                  item.line_level_discount_allocations ||
                  []
                ).forEach((allocation) => {
                  if (
                    allocation &&
                    allocation.discount_application &&
                    allocation.discount_application.title
                  ) {
                    validDiscounts.add(
                      allocation.discount_application.title.toUpperCase()
                    );
                  }
                });
              });

              if (
                !validDiscounts.has(
                  'KAHINA10'
                )
              ) {
                dispatchKahina10Removed();
              }
            } catch (error) {
              // Silent fallback
            }
          }, 300);
        }
      }
    );
  }

  /**
   * Initialize on DOM ready
   */
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initDiscountScript();
    }
  );

  /**
   * Re-initialize after Shopify cart updates
   */
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      () => {
        initDiscountScript();
      }
    );
  }

  /**
   * MutationObserver:
   * The cart drawer can be dynamically replaced
   * by Shopify's AJAX cart system.
   */
  const observer =
    new MutationObserver(() => {
      if (
        document.getElementById(
          'discount-code-container'
        )
      ) {
        initDiscountScript();
      }
    });

  if (document.body) {
    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  /**
   * Expose the initializer globally
   * for manual triggering if needed.
   */
  window.initDiscountScript =
    initDiscountScript;
})();